<template>
  <ion-page id="passwordreset-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
        <div v-if="hasError" >
          <ion-item color="warning">
            {{ message }}
          </ion-item>
        </div>
        <div v-else>
          <ion-item>
            {{ message }}
          </ion-item>
        </div>
        <div v-if="showForm">
          <ion-item>
            <ion-input label="Email" type="email" label-placement="fixed" 
                    placeholder="Enter email" :value="email"
                    @ionInput="emailInputChange">
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-button expand="block" size="large" @click="doUnsubscribe()" >Unsubscribe</ion-button>
          </ion-item>        
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

// https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

import { ref , watch } from 'vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { useGetData } from '@/composables/getData.js'
import { availableWidthHeight }  from '@/composables/screenSize'

const connectionStore = useConnectionStore()
  
const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

const urlParams =  new URLSearchParams(window.location.search)

const hasError = ref(false)
const message = ref("Click the button below to stop receiving to stop receiving the Chessvis email blast. They're usually sent out every couple of weeks but never more than weekly.")
const verify = ref("")
const email = ref("")

const showForm = ref(true)

var url_e = localStorage.getItem("url_email")

if (url_e != null) {
  hasError.value = false
  email.value = url_e
}

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })
 
updateWidthHeights()

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function emailInputChange(ev) {
    console.log("email ",ev)
    const value = ev.target.value;
    console.log("email",value)
    email.value = value.trim()
  }

function processJsonResponse (json) {
  console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  message.value = "Sorry to see you go."
}

function doUnsubscribe() {
  if (email.value == "") {
    message.value = "Please enter your email"
    return
  }

  message.value = "unsubscribing...."
  var formData = { 
    email : email.value
    }
  console.log("unsubscribe  formdata",formData)
  useGetData("geweb_unsubscribe.php", formData, processJsonResponse)
}



</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>
